import { trace } from 'owa-trace';
import { UserDataStoreRequestStatus } from '../data/schema/UserDataStoreSchema';

const USER_DATA_NOT_FOUND_ERROR_CODE = 404;
const USER_DATA_INVALID_REQUEST_ERROR_CODE = 400;
const USER_DATA_KEY_CONFLICT_ERROR_CODE = 409;

export function processUpdateResponse(
    response: Response,
    actionName: string
): Promise<UserDataStoreRequestStatus> {
    if (response.ok) {
        return Promise.resolve(UserDataStoreRequestStatus.SUCCESS);
    } else {
        switch (response.status) {
            case USER_DATA_NOT_FOUND_ERROR_CODE:
                return Promise.resolve(UserDataStoreRequestStatus.NOT_FOUND);
            case USER_DATA_INVALID_REQUEST_ERROR_CODE:
                return Promise.resolve(UserDataStoreRequestStatus.INVALID_DATA);
            case USER_DATA_KEY_CONFLICT_ERROR_CODE:
                return Promise.resolve(UserDataStoreRequestStatus.CONFLICT);
            default:
                logUserDataResponseError(
                    actionName,
                    'Request failed with status ' + response.status
                );
                return Promise.resolve(UserDataStoreRequestStatus.UNEXPECTED_ERROR);
        }
    }
}

export function logUserDataResponseError(actionName: string, errorText: string) {
    trace.info(`Error: [${actionName}]. Response: ${errorText}`);
}
